import React from 'react';
import { useVisitContext } from '@hooks';
import { HeaderLayout } from '@layouts';
import PrimaryButton from '@components/PrimaryButton';
import errorVisitBg from '@assets/error-visit-bg.png';
import { useStyles, useStylesButton } from './styles';

const ErrorVisitScreen = () => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const { errorMessage } = useVisitContext();

  return (
    <HeaderLayout>
      <div className={classes.container}>
        <div>
          <img src={errorVisitBg} alt="error-bg" />
          <div className={classes.textPart}>
            <p className={classes.title}>Oops!</p>
            <p className={classes.subTitle}>
              {errorMessage || 'Something went wrong'}
            </p>
          </div>
        </div>
        <PrimaryButton
          text="open my camera"
          classesButton={classesButton}
          handleClick={() => {}}
        />
      </div>
    </HeaderLayout>
  );
};

export default ErrorVisitScreen;
